import { render, staticRenderFns } from "./Societes.vue?vue&type=template&id=a70a9a60&"
import script from "./Societes.vue?vue&type=script&lang=js&"
export * from "./Societes.vue?vue&type=script&lang=js&"
import style0 from "./Societes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports